function extractVueFunctions () {
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"frontmatter-markdown"},[_c('h2',[_vm._v("Subscribe to our mailing list")]),_vm._v(" "),_c('p',[_vm._v("We will keep you up to date with practical information on how you could optimize your digital sales funnel.")])])}]

return { render, staticRenderFns }
}
const vueFunctions = extractVueFunctions()

module.exports = { 
      attributes: {"href":"/interactions/email/details","subscribe":"Subscribe","email":"Email","countdown":"Auto subscribe to our mailing list in # seconds.","cancel":"Cancel subscription","subject":"WhiteBox Subscription - {{from}} - {{rid}}","confirmationSubject":"WhitBox - Live demo","message":"WhiteBox email tracking subscription","confirmation":"https://templates.whitebox.pro/site/en/subscription.html?v=2"},
    
      vue: {
        component: {
          data: function () {
            return {
              templateRender: null
            }
          },
          render: function (createElement) {
            return this.templateRender ? this.templateRender() : createElement("div", "Rendering");
          },
          created: function () {
            this.templateRender = vueFunctions.render;
            this.$options.staticRenderFns = vueFunctions.staticRenderFns;
          }
        }
      },
     }